import Vue from "vue";
import VueI18n from "vue-i18n";

// 引入各个语言配置文件
import zh from "./zh.js";
import en from "./en.js";
import ja from "./jp.js";

Vue.use(VueI18n);
// 获取当前域名
let currentLanguage = localStorage.getItem("accept_language");

if (!currentLanguage) {
  localStorage.setItem("accept_language", "ja");
}

// 动态加载日文字体
function loadJapaneseFont(locale) {
  const fontId = 'japanese-font-style';
  const existingStyle = document.getElementById(fontId);

  if (locale === 'ja') {
    if (!existingStyle) {
      const style = document.createElement('style');
      style.id = fontId;
      style.textContent = `
        @font-face {
          font-family: 'Shippori Mincho';
          src: url('/ShipporiMincho-Regular.ttf') format('truetype');
          font-weight: normal;
          font-style: normal;
        }
        * {
          font-family: 'Shippori Mincho', sans-serif !important;
        }
      `;
      document.head.appendChild(style);
    }
  } else {
    if (existingStyle) {
      existingStyle.remove();
    }
  }
}

// 初始加载字体
const initialLocale = localStorage.getItem("accept_language") || "ja";
loadJapaneseFont(initialLocale);

// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  locale: initialLocale, // 语言标识
  // 添加多语言（每一个语言标示对应一个语言文件）
  messages: {
    zh,
    en,
    ja,
  }, // 隐藏警告
  // silentTranslationWarn: true,
});

// 监听语言切换，动态加载/卸载字体
i18n.vm.$watch('locale', (newLocale) => {
  loadJapaneseFont(newLocale);
});

// 暴露i18n
export default i18n;
